// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3oeBA","box":"WorkspacesBox_box__205IX","node":"WorkspacesBox_node__3pWRI"};